module.exports = __webpack_public_path__ + "img/nginxwise1.63aeace6.png";